// Закрытый перечень имён прикладных модулей (ADR-0083, п. 3 и 6).
//
// Это имена каталогов `backend/modules/` плюс `notifications`, который
// описан в `docs/spec/modules/notifications.md`, но ещё не перенесён.
// Перечень правится вместе с переименованием модуля. Имя, которого нет в
// перечне, клиент не покажет: это названная цена решения (ADR-0083, п. 3).

export const MODULE_NAMES = [
  "agent_governance",
  "audit",
  "ci_log",
  "ingest",
  "mcp",
  "notifications",
  "provider",
  "quota",
  "repo_host",
  "runner",
  "self_learning",
  "settings",
  "task",
  "task_tracker",
  "trust",
  "verification",
] as const;

export type ModuleName = (typeof MODULE_NAMES)[number];

const KNOWN: ReadonlySet<string> = new Set(MODULE_NAMES);

export function isModuleName(value: string): value is ModuleName {
  return KNOWN.has(value);
}
